import { Box, Typography } from '@mui/material'

const BuildingUuidRequired = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Gebäude-UUID erforderlich
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Bitte geben Sie eine Gebäude-UUID in der URL an, um auf die Anwendung zuzugreifen.
      </Typography>
    </Box>
  )
}

export default BuildingUuidRequired
